// import * as React from "react";
import logo from "assets/img/compleo_horizontal_azul.svg";

interface IProps {
    className: string;
}

export const LogoImported = (props: IProps) => {
    return <img className={props.className} src={logo} alt="Logo Compleo" />;
};

export const LogoAzul = (props: IProps) => {
    return <LogoImported className={props.className} />;
};

export default LogoAzul;
